import type { FormEventHandler } from "react"

import { Button, Input, Label } from "@coval/ui"

interface ClerkInvitationEmailStepProps {
  email: string
  error: string | null
  oauthPending: boolean
  requiresEnterpriseSso: boolean
  submitting: boolean
  onEmailChange: (email: string) => void
  onSubmit: FormEventHandler<HTMLFormElement>
}

export function ClerkInvitationEmailStep({
  email,
  error,
  oauthPending,
  requiresEnterpriseSso,
  submitting,
  onEmailChange,
  onSubmit,
}: ClerkInvitationEmailStepProps) {
  return (
    <form
      onSubmit={onSubmit}
      className="space-y-6"
      aria-describedby={error ? "signup-error" : undefined}
    >
      <div className="space-y-1">
        <h1 className="text-xl font-medium text-foreground text-center md:text-left">
          {requiresEnterpriseSso
            ? "Continue with your company"
            : "Confirm your email"}
        </h1>
        <p className="text-sm text-coval-text-muted">
          {requiresEnterpriseSso
            ? "Enter the work email address that received this invitation. We'll send you to your company's sign-in page."
            : "Enter the email address that received this organization invitation."}
        </p>
      </div>

      <div className="space-y-1">
        <Label className="font-medium" htmlFor="signup-invitation-email">
          Work email
        </Label>
        <Input
          id="signup-invitation-email"
          name="username"
          type="email"
          autoComplete="username"
          placeholder="you@company.com"
          value={email}
          onChange={(event) => onEmailChange(event.target.value)}
          required
          aria-label="Work email"
        />
      </div>

      {error && (
        <p
          id="signup-error"
          role="alert"
          className="rounded-md border border-red-500/40 bg-red-500/10 p-3 text-sm text-red-500"
        >
          {error}
        </p>
      )}

      <Button
        type="submit"
        className="w-full"
        disabled={submitting || oauthPending || !email.trim()}
      >
        {oauthPending
          ? "Redirecting…"
          : requiresEnterpriseSso
            ? "Continue with company SSO"
            : submitting
              ? "Saving…"
              : "Continue"}
      </Button>
    </form>
  )
}
